import { render, staticRenderFns } from "./modalNotasCreate.vue?vue&type=template&id=aa492e2c&"
import script from "./modalNotasCreate.vue?vue&type=script&lang=js&"
export * from "./modalNotasCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports